import { Box, styled, useTheme } from "@mui/material";
import { HEADER, NAV } from "../../config";

import ChooseCodeLanguage from "../../components/ChooseCodeLanguage";
import PageMap from "../../page/PageMap/PageMap";
import Header from "../Header/Index";
// import Scrollbar from "@/components/scrollbar";
import { useEffect, useRef } from "react";

const SPACING = 0;

export default function Index() {
  const theme = useTheme();
  const scrollRef = useRef<any>(null);

  useEffect(() => {
    const scrollable = scrollRef.current;

    if (scrollable?.contentWrapperEl) {
      scrollable.contentWrapperEl.id = "content-scroll-box";
    }
  }, []);

  return (
    <Box
      sx={{
        // mt: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
        width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
        ml: `${NAV.W_DASHBOARD}px`,
        backgroundColor:
          theme.palette.mode === "light"
            ? theme.palette.background.default
            : theme.palette.grey[700],
        minHeight: "100%",
        paddingBottom: "1px",
        position: "relative",
        zIndex: 10,
      }}
      id="scroll-box"
    >
      <Header />
      <Box
        sx={{
          height: `calc(100vh - ${HEADER.H_DASHBOARD_DESKTOP_OFFSET + 1}px)`,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <DarkBox className="dark-box" />
        <Box
          sx={{
            height: 1,
            overflow: "auto",
            position: "relative",
          }}
          id="test-scroll"
        >
          <DarkBoxBg>
            <ChooseCodeLanguageBox>
              <ChooseCodeLanguage />
            </ChooseCodeLanguageBox>
          </DarkBoxBg>
          <PageMap />
        </Box>
      </Box>
    </Box>
  );
}

const DarkBox = styled(Box)(({ theme }) => ({
  width: "40%",
  position: "absolute",
  // right: 0,
  left: "60%",
  bottom: 0,
  // top: `${HEADER.H_DASHBOARD_DESKTOP_OFFSET + SPACING}px`,
  top: 0,
  backgroundColor: theme.palette.grey[800],
  zIndex: -1,
}));

const DarkBoxBg = styled(Box)(({ theme }) => ({
  // width: "40%",
  width: "33%",
  position: "absolute",
  left: "60%",
  top: `0px`,
  backgroundColor: "transparent",
  zIndex: 2,
  height: "70px",
}));

const ChooseCodeLanguageBox = styled(Box)(({ theme }) => ({
  position: "fixed",
  width: "calc(40% - 124px)",
  // width: "40%",
  top: `${HEADER.H_DASHBOARD_DESKTOP_OFFSET + SPACING}px`,
  backgroundColor: theme.palette.grey[800],
  zIndex: 999,
  paddingLeft: "16px",
  paddingTop: "12px",
  height: "70px",
}));
